import styled from 'styled-components';
import { ScArrowButton } from '../../../../components/ArrowButton/styled';
import { ScCTAButton } from '../../../../components/CTAButton/styled';
import { fpx } from '../../../../styles/fluid';

export const ScPromoCard = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${fpx(12)};
  width: ${fpx(270)};

  @media (orientation: portrait) {
    gap: ${fpx(16)};
    width: ${fpx(276)};
  }
`;

export const ScCardBackground = styled.div`
  position: absolute;
  z-index: -1;
  top: ${fpx(-54)};
  left: ${fpx(-55)};
  width: ${fpx(364)};
  height: ${fpx(394)};
  pointer-events: none;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: fill;
  }

  @media (orientation: portrait) {
    top: ${fpx(-44.5)};
    left: ${fpx(-51)};
  }
`;

export const ScContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${fpx(12)};
  width: 100%;

  @media (orientation: portrait) {
    gap: ${fpx(8)};
  }
`;

export const ScOfferHeadline = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${fpx(5)};
  width: ${fpx(228)};
`;

// Glyphs at this size overflow the 80px line box and background-clip only paints inside the box, so the padding gives the texture room and the negative margin keeps the layout.
export const ScFsAmount = styled.span<{ $texture: string }>`
  display: block;
  min-width: ${fpx(144)};
  margin: ${fpx(-12)} ${fpx(-8)};
  padding: ${fpx(12)} ${fpx(8)};
  text-align: center;
  background-image: url(${({ $texture }) => $texture});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  font-family: "Nunito", sans-serif;
  font-size: ${fpx(120)};
  font-weight: 900;
  line-height: ${fpx(80)};
  white-space: nowrap;

  @media (orientation: portrait) {
    min-width: ${fpx(120)};
    font-size: ${fpx(100)};
  }
`;

export const ScFsLabel = styled.p`
  margin: 0;
  width: 100%;
  background-image: linear-gradient(0deg, #028b31 23.958%, #85f60e 88.542%);
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  -webkit-text-fill-color: transparent;
  font-family: "Nosifer", sans-serif;
  font-size: ${fpx(32)};
  font-weight: 400;
  line-height: ${fpx(40)};
  letter-spacing: -0.12em;
  text-align: center;
  text-transform: uppercase;
  white-space: pre;

  &.lang-fr-CA,
  &.lang-fr-CH {
    font-size: ${fpx(22)};
    word-spacing: 0.36em;
  }
`;

export const ScDetails = styled.div`
  display: contents;

  @media (orientation: portrait) {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${fpx(16)};
    width: 100%;
  }
`;

export const ScBenefits = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${fpx(10)};
  height: ${fpx(20)};

  @media (orientation: landscape) {
    &.lang-de {
      gap: ${fpx(6)};
    }
  }

  @media (orientation: portrait) {
    gap: ${fpx(12)};
    height: ${fpx(24)};
  }
`;

export const ScBenefit = styled.div`
  display: flex;
  align-items: center;
  gap: ${fpx(8)};
  height: ${fpx(20)};
  color: #fff;
  font-size: ${fpx(16)};
  font-weight: 700;
  line-height: normal;
  white-space: nowrap;

  img {
    display: block;
    width: ${fpx(20)};
    height: ${fpx(20)};
  }

  @media (orientation: portrait) {
    height: ${fpx(24)};
    font-size: ${fpx(14)};
  }
`;

export const ScBenefitsDivider = styled.span`
  flex-shrink: 0;
  width: 2px;
  height: ${fpx(16)};
  background: rgba(255, 255, 255, 0.2);

  @media (orientation: portrait) {
    height: ${fpx(24)};
  }
`;

export const ScActions = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${ScCTAButton} {
    width: 100%;
    height: ${fpx(40)};
    padding-inline: ${fpx(16)};
    font-family: inherit;
    font-size: ${fpx(16)};
    line-height: normal;
    letter-spacing: 0;
  }

  ${ScArrowButton} {
    width: 100%;
    height: ${fpx(40)};
    gap: ${fpx(8)};
    padding: ${fpx(12)};
    opacity: 0.6;
    color: #fff;
    font-size: ${fpx(14)};
    font-weight: 400;
    line-height: ${fpx(20)};

    .arrow-icon i {
      font-size: ${fpx(16)};
    }
  }
`;
